export default "__VITE_ASSET__DXlC_iQi__"